// ═══ 사진 확대 모달 (핀치줌 + 드래그 + 좌우 넘기기) ═══
// OrderDetail.js에서 분리. photos 배열 + viewIndex/setViewIndex만 받아 lightbox UI 렌더.
import React, { useState } from 'react';

function PhotoLightbox(props) {
  var photos = props.photos || [];
  var viewIndex = props.viewIndex;
  var setViewIndex = props.setViewIndex;

  var [imgScale, setImgScale] = useState(1);
  var [imgPos, setImgPos] = useState({ x: 0, y: 0 });
  var [isDragging, setIsDragging] = useState(false);
  var [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  var [lastPinchDist, setLastPinchDist] = useState(null);
  var [touchStart, setTouchStart] = useState(null);

  if (viewIndex === null || !photos[viewIndex]) return null;

  var getPinchDist = function(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };
  var resetZoom = function() { setImgScale(1); setImgPos({ x: 0, y: 0 }); };
  var close = function() { setViewIndex(null); resetZoom(); };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.95)',
      zIndex: 9999, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', touchAction: 'none',
    }}>
      <button onClick={close} style={{
        position: 'absolute', top: 16, right: 16, background: 'rgba(255,255,255,0.2)',
        border: 'none', color: '#fff', fontSize: 24, width: 40, height: 40,
        borderRadius: '50%', cursor: 'pointer', zIndex: 10,
      }}>×</button>
      <div style={{
        position: 'absolute', top: 16, left: '50%', transform: 'translateX(-50%)',
        color: '#fff', fontSize: 14, background: 'rgba(0,0,0,0.5)',
        padding: '4px 14px', borderRadius: 20, zIndex: 10,
      }}>{viewIndex + 1} / {photos.length}</div>
      {viewIndex > 0 && (
        <button onClick={function(e) { e.stopPropagation(); setViewIndex(viewIndex - 1); resetZoom(); }} style={{
          position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
          fontSize: 28, width: 44, height: 44, borderRadius: '50%', cursor: 'pointer', zIndex: 10,
        }}>‹</button>
      )}
      {viewIndex < photos.length - 1 && (
        <button onClick={function(e) { e.stopPropagation(); setViewIndex(viewIndex + 1); resetZoom(); }} style={{
          position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
          fontSize: 28, width: 44, height: 44, borderRadius: '50%', cursor: 'pointer', zIndex: 10,
        }}>›</button>
      )}
      {/\.(mp4|mov|avi|webm|3gp)$/i.test(photos[viewIndex].filename || photos[viewIndex].url || '')
        ? <video src={photos[viewIndex].url} controls autoPlay style={{ maxWidth: '95%', maxHeight: '75vh', borderRadius: 4 }} onClick={function(e) { e.stopPropagation(); }} />
        : <div style={{ overflow: 'hidden', width: '100%', height: '75vh', display: 'flex', alignItems: 'center', justifyContent: 'center', touchAction: 'none', cursor: imgScale > 1 ? 'grab' : 'default' }}
            onTouchStart={function(e) {
              if (e.touches.length === 2) { e.preventDefault(); setLastPinchDist(getPinchDist(e.touches)); }
              else if (e.touches.length === 1 && imgScale > 1) { setIsDragging(true); setDragStart({ x: e.touches[0].clientX - imgPos.x, y: e.touches[0].clientY - imgPos.y }); }
              else if (e.touches.length === 1) { setTouchStart(e.touches[0].clientX); }
            }}
            onTouchMove={function(e) {
              if (e.touches.length === 2 && lastPinchDist) {
                e.preventDefault();
                var newDist = getPinchDist(e.touches);
                var delta = newDist / lastPinchDist;
                setImgScale(function(s) { return Math.min(Math.max(s * delta, 1), 5); });
                setLastPinchDist(newDist);
              } else if (e.touches.length === 1 && isDragging && imgScale > 1) {
                setImgPos({ x: e.touches[0].clientX - dragStart.x, y: e.touches[0].clientY - dragStart.y });
              }
            }}
            onTouchEnd={function(e) {
              setLastPinchDist(null); setIsDragging(false);
              if (imgScale <= 1.1) resetZoom();
              if (imgScale <= 1 && touchStart !== null) {
                var diff = e.changedTouches[0].clientX - touchStart;
                if (diff > 50 && viewIndex > 0) { setViewIndex(viewIndex - 1); resetZoom(); }
                if (diff < -50 && viewIndex < photos.length - 1) { setViewIndex(viewIndex + 1); resetZoom(); }
              }
              setTouchStart(null);
            }}
            onWheel={function(e) {
              e.preventDefault();
              var delta = e.deltaY > 0 ? 0.9 : 1.1;
              var newScale = Math.min(Math.max(imgScale * delta, 1), 5);
              setImgScale(newScale);
              if (newScale <= 1) setImgPos({ x: 0, y: 0 });
            }}
            onMouseDown={function(e) { if (imgScale > 1) { setIsDragging(true); setDragStart({ x: e.clientX - imgPos.x, y: e.clientY - imgPos.y }); } }}
            onMouseMove={function(e) { if (isDragging && imgScale > 1) setImgPos({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y }); }}
            onMouseUp={function() { setIsDragging(false); }}
            onMouseLeave={function() { setIsDragging(false); }}
          >
            <img src={photos[viewIndex].url} alt={photos[viewIndex].memo || ''} draggable={false}
              onDoubleClick={function() { if (imgScale > 1) resetZoom(); else { setImgScale(2.5); } }}
              style={{ maxWidth: '100%', maxHeight: '75vh', objectFit: 'contain', borderRadius: 4, transform: 'scale(' + imgScale + ') translate(' + (imgPos.x / imgScale) + 'px, ' + (imgPos.y / imgScale) + 'px)', transition: isDragging ? 'none' : 'transform 0.2s ease', userSelect: 'none' }} />
          </div>
      }
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
        {photos[viewIndex].memo && (
          <div style={{ color: '#fff', fontSize: 14, background: 'rgba(255,255,255,0.15)', padding: '6px 16px', borderRadius: 8 }}>{photos[viewIndex].memo}</div>
        )}
        {photos[viewIndex].url && !photos[viewIndex].url.startsWith('blob:') && (
          <button
            onClick={function(e) {
              e.stopPropagation();
              var url = photos[viewIndex].url.replace(/\/uploads\/eval\/(\d+)\/(.+)/, '/api/eval/orders/$1/photos/$2/download');
              window.open(url, '_blank');
            }}
            style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#fff', fontSize: 13, background: 'rgba(255,255,255,0.2)', padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer', fontWeight: 600, fontFamily: "'Pretendard',sans-serif" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            저장
          </button>
        )}
      </div>
      <div style={{ color: '#666', fontSize: 11, marginTop: 8 }}>스와이프 넘기기 · 핀치/휠 확대 · 더블탭 · × 닫기</div>
    </div>
  );
}

export default PhotoLightbox;
